import { Injectable } from '@angular/core';
import { AbwConfirmDialogComponent } from './abw-confirm-dialog.component';
import { MatDialog } from '@angular/material/dialog';

@Injectable()
export class AbwConfirmDialogService {
    constructor(
        private dialog: MatDialog
    ) {
    }

    showConfirmDialog(title: string, message: string) {
        return new Promise<boolean>((resolve, reject) => {
            const dialogRef = this.dialog.open(AbwConfirmDialogComponent, {
                maxWidth: "400px",
                data: { title: title, message: message }
            });

            dialogRef.afterClosed().subscribe(dialogResult => {
                resolve(dialogResult);
            });
        });
    }
}